import React from 'react';
import { Button } from '../../Button';
import { formatClassName } from '../../../utils';

import { FilterButtonProps } from './types';

export const FilterButton: React.FC<FilterButtonProps> = ({ label, selected, highlighted, ...rest }) => {
  return (
    <Button
      className={formatClassName({
        selected: highlighted,
        'filter-button': true,
        'ui-default': true,
      })}
      label={(selected !== true && selected) || label}
      rightIcon="angle-down"
      style="elevated"
      {...rest}
    />
  );
};
